(function () {
    'use strict';

    angular
        .module('physicalFairs')
        .controller('PhysicalFairStudentsController', PhysicalFairStudentsController);

    PhysicalFairStudentsController.$inject = ['$uibModal', 'ExpoService', 'CitiesByExpoService', 'PhysicalFairService','$timeout'];

    function PhysicalFairStudentsController($uibModal, ExpoService, CitiesByExpoService, PhysicalFairService, $timeout) {
        var vm = this;

        vm.datePicker = {startDate: moment(), endDate: moment()};
        vm.optionsDatepickerA;
        vm.optionsDatepickerB;
        vm.expoLabelA            = '';
        vm.expoLabelB            = '';
        vm.typeOfRangeSelected   = '';
        vm.requiredCities        = false;
        vm.typeOfRange           = [
                                        {name:'By date'},
                                        {name:'By day'}
        ];
        vm.reportTypeSelected   = {name:'Comparative Student Registrations'};
        vm.reportType           = [
                                        {name:'Comparative Student Registrations'},
                                        {name:'Student registrations by roadshow/city'}
                                   ];
        vm.data                  = [];
        vm.dataGraphAge          = [];
        vm.dataGraphGender       = [];
        vm.dataGraphIsParent     = [];
        vm.dataGraphHowPlanning  = [];
        vm.flagForViewGraph      = false;
        vm.expoA;
        vm.expoASelected;
        vm.cityASelected;
        vm.cityA;
        vm.expoB;
        vm.expoBSelected;
        vm.cityBSelected;
        vm.cityB;
        vm.dateRangeA            = [];
        vm.dateRangeB            = [];
        /* START DATES BY CITY */
        vm.startA                = [];
        vm.startB                = [];
        vm.endA                  = [];
        vm.endB                  = [];
        vm.selectExpo            = selectExpo;
        vm.selectCitiesByExpo    = selectCitiesByExpo;
        vm.getByFilter           = getByFilter;
        vm.selectedCity          = selectedCity;
        vm.onChangeTypeRange     = onChangeTypeRange;

        function activate() {
            vm.selectExpo();
        }

        function selectExpo () {
            ExpoService.getExpos().then(function(response){
                    vm.expoA = response.data;
                    vm.expoB = response.data;
            }).catch(function(err) {

            });
        }

        function onChangeTypeRange() {
            if(vm.typeOfRangeSelected.name == 'By day') {
                vm.expoASelected    = '';
                vm.cityASelected    = '';
                vm.dateRangeA       = [];
                vm.expoBSelected    = '';
                vm.cityBSelected    = '';
                vm.dateRangeB       = [];
                vm.requiredCities   = true;
            } else {
                vm.expoASelected    = '';
                vm.cityASelected     = '';
                vm.dateRangeA       = [];
                vm.expoBSelected    = '';
                vm.cityBSelected    = '';
                vm.dateRangeB       = [];
                vm.requiredCities   = false;
            }

        }

        function selectCitiesByExpo (type) {
                var params = [];
                if(type === 'A') {
                    params['expo_id']  = vm.expoASelected.id;
                    params['city_id']  = null;
                    vm.cityA = '';
                    ExpoService.getDateOfExpo(params).then(function(response){
                        var start;
                        var end;
                        /* FIX ME: I'M ALWAYS ADDING A DAY IN DATES DATABASE COMES*/
                        start = new Date(response.data[0].startDate+' 00:00:00');
                        end = new Date(response.data[0].endDate+' 00:00:00');
                        /* SET (START AND END B) FOR FILTER BY TYPE RANGE = 'By day' */
                        vm.startA = moment.utc(start).subtract(30, 'days');
                        vm.endA   = moment.utc(end).subtract(1, 'days');
                        vm.optionsDatepickerA = {
                            ranges: {
                                'Today': [moment(), moment()],
                                '1 day before': [moment(start).subtract(1, 'days'), moment.utc(end).subtract(1, 'days')],
                                '2 days before': [moment(start).subtract(2, 'days'), moment.utc(end).subtract(1, 'days')],
                                '3 days before': [moment(start).subtract(3, 'days'), moment.utc(end).subtract(1, 'days')],
                                '4 days before': [moment(start).subtract(4, 'days'), moment.utc(end).subtract(1, 'days')],
                                '5 days before': [moment(start).subtract(5, 'days'), moment.utc(end).subtract(1, 'days')],
                                '6 days before': [moment(start).subtract(6, 'days'), moment.utc(end).subtract(1, 'days')],
                                '7 days before': [moment(start).subtract(7, 'days'), moment.utc(end).subtract(1, 'days')],
                                '8 days before': [moment(start).subtract(8, 'days'), moment.utc(end).subtract(1, 'days')],
                                '9 days before': [moment(start).subtract(9, 'days'), moment.utc(end).subtract(1, 'days')],
                                '10 days before':[moment(start).subtract(10, 'days'), moment.utc(end).subtract(1, 'days')],
                                '3 weeks before': [moment(start).subtract(3, 'weeks'),moment.utc(end).subtract(1, 'days')],
                                '4 weeks before': [moment(start).subtract(30, 'days'),moment.utc(end).subtract(1, 'days')]
                            }
                        };
                    });
                } else {
                    params['expo_id']  = vm.expoBSelected.id;
                    params['city_id']  = null;
                    vm.cityB = '';
                    ExpoService.getDateOfExpo(params).then(function(response){
                        var start;
                        var end;
                        start = new Date(response.data[0].startDate+' 00:00:00');
                        end = new Date(response.data[0].endDate+' 00:00:00');
                        /* SET (START AND END B) FOR FILTER BY TYPE RANGE = 'By day' */
                        vm.startB = moment.utc(start).subtract(30, 'days');
                        vm.endB   = moment.utc(end).subtract(1, 'days');
                        vm.optionsDatepickerB = {
                            ranges: {
                                'Today': [moment(), moment()],
                                '1 day before': [moment(start).subtract(1, 'days'), moment.utc(end).subtract(1, 'days')],
                                '2 days before': [moment(start).subtract(2, 'days'), moment.utc(end).subtract(1, 'days')],
                                '3 days before': [moment(start).subtract(3, 'days'), moment.utc(end).subtract(1, 'days')],
                                '4 days before': [moment(start).subtract(4, 'days'), moment.utc(end).subtract(1, 'days')],
                                '5 days before': [moment(start).subtract(5, 'days'), moment.utc(end).subtract(1, 'days')],
                                '6 days before': [moment(start).subtract(6, 'days'), moment.utc(end).subtract(1, 'days')],
                                '7 days before': [moment(start).subtract(7, 'days'), moment.utc(end).subtract(1, 'days')],
                                '8 days before': [moment(start).subtract(8, 'days'), moment.utc(end).subtract(1, 'days')],
                                '9 days before': [moment(start).subtract(9, 'days'), moment.utc(end).subtract(1, 'days')],
                                '10 days before':[moment(start).subtract(10, 'days'), moment.utc(end).subtract(1, 'days')],
                                '3 weeks before': [moment(start).subtract(3, 'weeks'),moment.utc(end).subtract(1, 'days')],
                                '4 weeks before': [moment(start).subtract(30, 'days'),moment.utc(end).subtract(1, 'days')]
                            }
                        };
                    });
                }
                CitiesByExpoService.getCities(params['expo_id']).then(function(response){
                    if(type === 'A') {
                            vm.cityASelected = '';
                            vm.dateRangeA    = [];
                            vm.cityA         = response.data;
                    } else {
                            vm.cityBSelected = '';
                            vm.dateRangeB    = [];
                            vm.cityB         = response.data;
                    }
                }).catch(function(err) {
                });
        }

        function selectedCity (type) {
            var params = [];
            if(type === 'A') {
                vm.dateRangeA = '';
                params['expo_id']  = vm.expoASelected.id;
                params['city_id']  = vm.cityASelected.id;
                ExpoService.getDateOfExpo(params).then(function(response){
                    var start;
                    var end;

                    /* FIX ME: I'M ALWAYS ADDING A DAY IN DATES DATABASE COMES*/
                    start = new Date(response.data[0].startDate);
                    end = new Date(response.data[0].endDate);
                    // start.setDate(start.getDate() + 1);
                    // end.setDate(end.getDate() + 1);

                    /* SET (START AND END A) FOR FILTER BY TYPE RANGE = 'By day' */
                    vm.startA = moment.utc(start).subtract(30, 'days');
                    vm.endA   = moment.utc(end).subtract(1, 'days');

                    vm.optionsDatepickerA = {
                        ranges: {
                            'Today': [moment.utc(), moment.utc()],
                            '1 day before': [moment.utc(start).subtract(1, 'days'), moment.utc(end).subtract(1, 'days')],
                            '2 days before': [moment.utc(start).subtract(2, 'days'), moment.utc(end).subtract(1, 'days')],
                            '3 days before': [moment.utc(start).subtract(3, 'days'), moment.utc(end).subtract(1, 'days')],
                            '4 days before': [moment.utc(start).subtract(4, 'days'), moment.utc(end).subtract(1, 'days')],
                            '5 days before': [moment.utc(start).subtract(5, 'days'), moment.utc(end).subtract(1, 'days')],
                            '6 days before': [moment.utc(start).subtract(6, 'days'), moment.utc(end).subtract(1, 'days')],
                            '7 days before': [moment.utc(start).subtract(7, 'days'), moment.utc(end).subtract(1, 'days')],
                            '8 days before': [moment.utc(start).subtract(8, 'days'), moment.utc(end).subtract(1, 'days')],
                            '9 days before': [moment.utc(start).subtract(9, 'days'), moment.utc(end).subtract(1, 'days')],
                            '10 days before':[moment.utc(start).subtract(10, 'days'), moment.utc(end).subtract(1, 'days')],
                            '3 weeks before': [moment.utc(start).subtract(3, 'weeks'), moment.utc(end).subtract(1, 'days')],
                            '4 weeks before': [moment.utc(start).subtract(30, 'days'), moment.utc(end).subtract(1, 'days')]
                        }
                    };
                });

            } else {
                params['expo_id']  = vm.expoBSelected.id;
                params['city_id']  = vm.cityBSelected.id;
                vm.dateRangeB = '';
                ExpoService.getDateOfExpo(params).then(function(response){
                    var start;
                    var end;

                    /* FIX ME: I'M ALWAYS ADDING A DAY IN DATES DATABASE COMES*/
                    start = new Date(response.data[0].startDate);
                    end = new Date(response.data[0].endDate);
                    //start.setDate(start.getDate() + 1);
                    //end.setDate(end.getDate() + 1);

                    /* SET (START AND END B) FOR FILTER BY TYPE RANGE = 'By day' */
                    vm.startB = moment.utc(start).subtract(30, 'days');
                    vm.endB   = moment.utc(end).subtract(1, 'days');

                    vm.optionsDatepickerB = {
                        ranges: {
                            'Today': [moment.utc(), moment.utc()],
                            '1 day before': [moment.utc(start).subtract(1, 'days'), moment.utc(end).subtract(1, 'days')],
                            '2 days before': [moment.utc(start).subtract(2, 'days'), moment.utc(end).subtract(1, 'days')],
                            '3 days before': [moment.utc(start).subtract(3, 'days'), moment.utc(end).subtract(1, 'days')],
                            '4 days before': [moment.utc(start).subtract(4, 'days'), moment.utc(end).subtract(1, 'days')],
                            '5 days before': [moment.utc(start).subtract(5, 'days'), moment.utc(end).subtract(1, 'days')],
                            '6 days before': [moment.utc(start).subtract(6, 'days'), moment.utc(end).subtract(1, 'days')],
                            '7 days before': [moment.utc(start).subtract(7, 'days'), moment.utc(end).subtract(1, 'days')],
                            '8 days before': [moment.utc(start).subtract(8, 'days'), moment.utc(end).subtract(1, 'days')],
                            '9 days before': [moment.utc(start).subtract(9, 'days'), moment.utc(end).subtract(1, 'days')],
                            '10 days before':[moment.utc(start).subtract(10, 'days'), moment.utc(end).subtract(1, 'days')],
                            '3 weeks before': [moment.utc(start).subtract(15, 'days'),moment.utc(end).subtract(1, 'days')],
                            '4 weeks before': [moment.utc(start).subtract(30, 'days'),moment.utc(end).subtract(1, 'days')]
                        }
                    };
                });
            }
        }

        function getByFilter() {
            vm.query = {};
            vm.query['typeOfRange']         = vm.typeOfRangeSelected.name;
            vm.query['reportTypeSelected']  = vm.reportTypeSelected.name;

            if(vm.query['typeOfRange'] == 'By day') {
                vm.query['dateRangeStartA'] = vm.startA.format('YYYY-MM-DD');
                vm.query['dateRangeEndA']   = vm.endA.format('YYYY-MM-DD');
                if(vm.reportTypeSelected.name == 'Comparative Student Registrations') {
                    vm.query['dateRangeStartB'] = vm.startB.format('YYYY-MM-DD');
                    vm.query['dateRangeEndB']   = vm.endB.format('YYYY-MM-DD');
                }
            } else {
                vm.query['dateRangeStartA'] = moment.utc(vm.dateRangeA.startDate).format('YYYY-MM-DD');
                vm.query['dateRangeEndA']   = moment.utc(vm.dateRangeA.endDate).format('YYYY-MM-DD');
                if(vm.reportTypeSelected.name == 'Comparative Student Registrations') {
                    vm.query['dateRangeStartB'] = moment.utc(vm.dateRangeB.startDate).format('YYYY-MM-DD');
                    vm.query['dateRangeEndB'] = moment.utc(vm.dateRangeB.endDate).format('YYYY-MM-DD');
                }
            }
            if(typeof vm.cityASelected !== 'undefined' && typeof vm.cityBSelected !== 'undefined') {
                vm.query['cityA']   = vm.cityASelected.id;
                if(vm.reportTypeSelected.name == 'Comparative Student Registrations') {
                    vm.query['cityB']   = vm.cityBSelected.id;
                }
            }
            vm.query['expoA'] = vm.expoASelected.id;
            vm.expoLabelA     = vm.expoASelected.name;
            if(vm.reportTypeSelected.name == 'Comparative Student Registrations') {
                vm.query['expoB'] = vm.expoBSelected.id;
                vm.expoLabelB     = vm.expoBSelected.name;
            }
            PhysicalFairService.getByFilterStudents(vm.query).then(function(response){
                vm.data = response.data;
            }).catch(function(err) {
            });
            /*GENDER*/
            PhysicalFairService.getGenderOfStudents(vm.query).then(function(response){
                vm.dataGraphGender = response.data;
            }).catch(function(err) {
            });
            /*IS_PARENT*/
            PhysicalFairService.getIsParentOfStudents(vm.query).then(function(response){
                vm.dataGraphIsParent = response.data;
            }).catch(function(err) {
            });
            /*HOW PLANNIG PAY*/
            PhysicalFairService.getHowPlanningOfStudents(vm.query).then(function(response){
                vm.dataGraphHowPlanning = response.data;
            }).catch(function(err) {
            });
            /*AGE*/
            PhysicalFairService.getAgeOfStudents(vm.query).then(function(response){
                vm.dataGraphAge = response.data;
            }).catch(function(err) {
            });
            vm.flagForViewGraph = true;
        }
        activate();
    }
})();